// extracted by mini-css-extract-plugin
module.exports = {"pik-standard-description":"_6f25b66c20--pik-standard-description--35hmi"};